module.exports = __webpack_public_path__ + "7d70f776dd685e11842d676e3d96282d.png";